import React from "react";
import SignedRoutes from "./signed.routes";
import NotSignedRoutes from "./notSigned.routes";
import VerificationRoutes from "./verification.routes";
import AdminRoutes from "./admin.routes";
import { useWhitelabel } from "../context/whitelabel.context";
import { useAuth } from "../context/auth.context";

export default function Router(){
    const {coresRoot} = useWhitelabel();
    const {authStatus, verifiedUser, isAdmin, adminAccessMode} = useAuth()

    const renderAuthenticatedRoutes = () => {
        if (verifiedUser === false) {
            return <VerificationRoutes/>
        }

        if (isAdmin) {
            if (adminAccessMode === 'panel') {
                return <AdminRoutes/>
            }

            if (adminAccessMode !== 'site') {
                return <AdminRoutes choiceOnly={true}/>
            }
        }

        return <SignedRoutes/>
    }

    
    
    return (
        <>
            <style>
                {coresRoot}
            </style>

            {!authStatus ? <NotSignedRoutes/> : renderAuthenticatedRoutes()}
        </>
    )
}